import {useDebugValue} from 'react';

import classNames from 'classnames';

import {useSearchFormContext} from '../../../hooks';

const componentClassNamespace = 'search-form';
const componentClassName = `${componentClassNamespace}__fields`;
const componentInnerClassName = `${componentClassName}-inner`;

function useComponent() {
    const {
        media: {
            settings: {
                isMobile
            }
        },
        form: {
            options: {
                showDestinationField,
                showDatesField,
                showGuestsField,
                showSubmitButton
            }
        }
    } = useSearchFormContext();

    const className = classNames(componentClassName);
    const innerClassName = classNames(componentInnerClassName);

    const includeInner = !!isMobile;

    const result = {
        className,
        innerClassName,
        includeInner,
        showDestinationField,
        showDatesField,
        showGuestsField,
        showSubmitButton
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
